import {
  alpha,
  Autocomplete,
  AutocompleteChangeDetails,
  AutocompleteChangeReason,
  TextField,
} from "@mui/material";
import React from "react";

export interface AutocompleteOption {
  id: string;
  label: string;
}

interface AutocompleteSelectProps {
  id: string;
  stateValue?: AutocompleteOption | null;
  options: AutocompleteOption[];
  label: string;
  placeholder?: string;
  onHandleChange: (
    event: React.SyntheticEvent,
    value: AutocompleteOption | null,
    reason: AutocompleteChangeReason,
    details?: AutocompleteChangeDetails<AutocompleteOption>
  ) => void;
  error: boolean;
  helperText?: React.ReactNode;
  disabled?: boolean;
}

const AutocompleteSelect: React.FC<AutocompleteSelectProps> = ({
  id,
  stateValue,
  options,
  label,
  placeholder,
  onHandleChange,
  error,
  helperText,
  disabled,
}) => {
  return (
    <Autocomplete
      id={id}
      value={stateValue ?? null}
      onChange={onHandleChange}
      options={options}
      disabled={disabled}
      sx={(theme) => ({
        "& .MuiOutlinedInput-root": {
          borderRadius: "14px",
          paddingRight: "12px",
          backgroundColor:
            theme.palette.mode === "dark"
              ? alpha(theme.palette.background.default, 0.28)
              : theme.palette.background.paper,
          transition: "background-color 0.2s ease, border-color 0.2s ease",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderWidth: 2,
          borderColor: "divider",
        },
        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "primary.main",
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            borderColor: "primary.main",
            borderWidth: 2,
          },
        "& .MuiInputBase-input": {
          color: "text.primary",
          fontWeight: 500,
        },
      })}
      noOptionsText="Nenhum cliente encontrado"
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => option.label}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

export default AutocompleteSelect;
